import { render } from "./AllBillersView.vue?vue&type=template&id=13915656"
import script from "./AllBillersView.vue?vue&type=script&lang=js"
export * from "./AllBillersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__